// it — checkin/quickCheck/stepTracker blocks translated.
export const it = {
  "common": {
    "loading": "Caricamento...",
    "save": "Salva",
    "cancel": "Annulla",
    "delete": "Elimina",
    "edit": "Modifica",
    "close": "Chiudi",
    "confirm": "Conferma",
    "back": "Indietro",
    "next": "Avanti",
    "submit": "Invia",
    "search": "Cerca",
    "select": "Seleziona",
    "or": "Oppure",
    "and": "e",
    "note": "Nota",
    "viewAll": "Vedi tutto",
    "learnMore": "Scopri di più",
    "getStarted": "Inizia ora",
    "continue": "Continua",
    "saving": "Salvataggio in corso…"
  },
  "nav": {
    "dashboard": "Home",
    "nutrition": "Alimentazione",
    "family": "Famiglia",
    "care": "Servizi",
    "careShort": "Servizi",
    "checkIn": "Check-in",
    "insights": "Analisi",
    "trends": "Tendenze",
    "habits": "Abitudini",
    "medications": "Farmaci",
    "expertSupport": "Supporto esperti",
    "profile": "Profilo",
    "healthHub": "Hub Salute",
    "support": "Assistenza",
    "wellness": "Benessere",
    "education": "Formazione",
    "community": "Community",
    "preventiveHealth": "Prevenzione",
    "womensHealth": "Salute Donna",
    "reminders": "Promemoria salute",
    "meals": "Pasti",
    "orders": "Ordini",
    "subscription": "Abbonamento",
    "logout": "Esci"
  },

  "navShort": {
    "dashboard": "Home",
    "nutrition": "Nutrizione",
    "family": "Famiglia",
    "care": "Servizi",
    "support": "Aiuto",
    "profile": "Profilo"
  },
  "auth": {
    "login": "Accedi",
    "register": "Crea account",
    "logout": "Disconnettiti",
    "email": "Email",
    "password": "Password",
    "name": "Nome e cognome",
    "forgotPassword": "Password dimenticata?",
    "noAccount": "Non hai un account?",
    "haveAccount": "Hai già un account?",
    "signInHere": "Accedi qui",
    "signUpHere": "Registrati qui",
    "welcomeBack": "Bentornato!",
    "getStarted": "Cominciamo subito",
    "biometricLogin": "Accesso biometrico",
    "biometricHelper": "Usa impronta digitale, Face ID o Windows Hello",
    "vendorLogin": "Accesso fornitore",
    "createOne": "Creane uno",
    "tagline": "Prenditi cura della tua salute — un semplice gesto quotidiano.",
    "takes30s": "Richiede meno di 30 secondi",
    "emailPlaceholder": "tu@esempio.it",
    "passwordPlaceholder": "Inserisci la password",
    "checking": "Verifica in corso…",
    "continue": "Continua",
    "secureMessage": "Sicuro e riservato — i tuoi dati sono protetti",
    "biometricSoon": "Accesso biometrico — In arrivo",
    "sessionExpired": "Sessione scaduta. Accedi di nuovo per riprendere da dove avevi interrotto.",
    "showPassword": "Mostra password",
    "hidePassword": "Nascondi password",
    "vendor": {
      "title": "Accesso Partner Fornitore",
      "subtitle": "Accedi alla tua dashboard fornitore HealthLoop",
      "businessEmail": "Email aziendale",
      "emailPlaceholder": "fornitore@azienda.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Accesso in corso...",
      "signIn": "Accedi",
      "notVendorYet": "Non sei ancora un partner fornitore?",
      "registerBusiness": "Registra la tua attività",
      "areYouUser": "Sei un utente?",
      "userLogin": "Accesso Utente",
      "welcomeBackToast": "Bentornato!",
      "genericError": "Accesso fallito. Riprova."
    },
    "admin": {
      "backToUserLogin": "Accesso utente",
      "title": "Accesso Amministratore",
      "restrictedBadge": "Riservato",
      "tagline": "Console operatore HealthLoop — credenziali admin richieste.",
      "emailLabel": "Email amministratore",
      "emailPlaceholder": "admin@tuodominio.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Inserisci la password admin",
      "signingIn": "Accesso in corso…",
      "submit": "Accedi alla console admin",
      "secureNote": "Connessione sicura · sessione crittografata",
      "restrictedTitle": "Questa area è riservata agli amministratori.",
      "restrictedBody": "Hai effettuato l'accesso, ma il tuo account non dispone dei permessi di amministratore. Esci per provare con un altro account o torna all'app principale.",
      "signOut": "Esci",
      "backToApp": "Torna all'app"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Come ti senti oggi?",
      "subtitle": "Check-in rapido — richiede meno di 60 secondi"
    },
    "section1": {
      "title": "Cosa noti di particolare oggi?",
      "hint": "(Seleziona tutto quello che ti riguarda)"
    },
    "environment": {
      "title": "L'ambiente intorno a te",
      "hint": "Aiutaci a capire dove hai passato la giornata"
    },
    "basicChecks": {
      "title": "Controlli rapidi di base",
      "hint": "Opzionali ma utili"
    },
    "validation": {
      "pickOne": "Per favore, rispondi ad almeno una domanda"
    },
    "submit": {
      "cta": "Ricevi i miei consigli",
      "saving": "Salvataggio...",
      "analyzing": "Analizzo le tue abitudini di benessere...",
      "savedToast": "✅ Check-in salvato! Analizzo le tue abitudini..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Contapassi",
      "subtitle": "Monitoraggio semplice e trasparente dell'attività",
      "backToDashboard": "Torna alla bacheca"
    },
    "today": {
      "title": "I passi di oggi",
      "goalProgress": "{{current}} / {{goal}} passi",
      "goalReached": "Obiettivo raggiunto — ottimo lavoro!",
      "keepGoing": "Continua così — sei sulla strada giusta."
    },
    "streak": {
      "label": "Serie attuale",
      "days": "{{count}} giorno",
      "daysPlural": "{{count}} giorni"
    },
    "badges": {
      "title": "Traguardi",
      "empty": "Otterrai dei traguardi man mano che crei la tua routine."
    },
    "reminders": {
      "title": "Incentivi al movimento",
      "hint": "Piccoli promemoria per fare due passi se stai seduto troppo a lungo.",
      "enabled": "Attivati",
      "disabled": "Disattivati"
    },
    "insights": {
      "weeklyAverage": "Media settimanale",
      "weeklyGoal": "Obiettivo settimanale"
    },
    "actions": {
      "connect": "Collega una fonte dati",
      "manualLog": "Aggiungi passi manualmente",
      "changeGoal": "Cambia obiettivo giornaliero"
    }
  },
  "checkin": {
    "header": {
      "title": "Check-in quotidiano",
      "subtitle": "Richiede meno di 60 secondi",
      "restDayLink": "Oggi non me la sento"
    },
    "snapshot": {
      "title": "La tua bacheca, aggiornata",
      "healthScore": "Punteggio benessere",
      "todayTasks": "Attività di oggi",
      "dayStreak": "giorni consecutivi"
    },
    "resume": {
      "banner": "Hai ripreso da dove avevi lasciato",
      "startFresh": "Ricomincia",
      "dismiss": "Chiudi"
    },
    "progress": {
      "allSet": "Tutto pronto",
      "step": "Passaggio {{current}} di {{total}}",
      "ariaLabel": "Progresso check-in quotidiano: {{done}} di {{total}} sezioni completate"
    },
    "insights": {
      "title": "Le tue analisi del benessere",
      "subtitle": "Personalizzate per te, oggi",
      "insightForYou": "Un consiglio per te",
      "simpleActions": "Semplici passi che puoi fare",
      "whenToSeekHelp": "Quando chiedere supporto",
      "nhsAdvice": "In caso di dubbi, contatta il tuo medico di base",
      "backToDashboard": "Torna alla bacheca",
      "newCheckIn": "Nuovo check-in",
      "disclaimer": "HealthLoop offre consigli sul benessere, non diagnosi."
    },
    "restDay": {
      "title": "Il riposo fa parte del ritmo.",
      "body": "Saremo qui domani, quando vorrai.",
      "streakNote": "I tuoi progressi non sono andati persi — si stanno solo riposando.",
      "backToDashboard": "Torna alla bacheca",
      "changedMind": "In realtà, vorrei fare il check-in."
    },
    "feelings": {
      "title": "Come ti senti oggi?",
      "hint": "Seleziona tutto quello che senti",
      "tired": "Sento stanchezza",
      "headache": "Mal di testa",
      "stressed": "Sotto stress o con troppi pensieri",
      "pain": "Dolori muscolari o fastidi",
      "okay": "Oggi mi sento bene"
    },
    "basics": {
      "title": "Le tue basi",
      "sleepQ": "Hai dormito bene stanotte?",
      "waterQ": "Hai bevuto abbastanza acqua oggi?",
      "foodQ": "Hai mangiato in modo equilibrato oggi?",
      "activityQ": "Quanto movimento hai fatto oggi?",
      "yes": "Sì",
      "notReally": "Non proprio",
      "notYet": "Non ancora",
      "notActive": "Poco movimento",
      "lightActivity": "Attività leggera",
      "active": "Attività intensa"
    },
    "mind": {
      "title": "Mente ed energia",
      "stressQ": "Qual è il tuo livello di stress oggi?",
      "moodQ": "Com'è il tuo umore oggi?",
      "energyQ": "Com'è il tuo livello di energia oggi?",
      "low": "Basso",
      "moderate": "Moderato",
      "high": "Alto",
      "neutral": "Neutro",
      "good": "Buono",
      "okay": "Così così"
    },
    "day": {
      "title": "La tua giornata",
      "routineQ": "Oggi hai seguito la tua solita routine?",
      "yes": "Sì",
      "no": "No"
    },
    "environment": {
      "title": "L'ambiente intorno a te",
      "describeQ": "Come descriveresti l'ambiente in cui sei stato?",
      "comfortable": "😊 Confortevole",
      "slightlyUncomfortable": "😐 Un po' fastidioso",
      "challenging": "😓 Difficile",
      "affectedQ": "L'ambiente ha influenzato come ti senti?",
      "yes": "Sì",
      "no": "No",
      "exposureLabel": "Esposizione (seleziona tutte le opzioni)",
      "heat": "🌡️ Caldo",
      "cold": "❄️ Freddo",
      "noise": "🔊 Rumore",
      "dustSmoke": "💨 Polvere o fumo",
      "crowded": "👥 Spazio affollato",
      "none": "✅ Nessuna"
    },
    "submit": {
      "analyzing": "Analizzo le tue abitudini di benessere...",
      "cta": "Guarda i miei consigli benessere"
    },
    "toast": {
      "savedFull": "Check-in salvato! La bacheca è aggiornata.",
      "savedShort": "Check-in salvato."
    }
  },
  "onboarding": {
    "welcome": "Benvenuto",
    "completeSetup": "Completa configurazione",
    "stepProgress": "Passaggio {{step}} di {{total}}",
    "percentComplete": "{{percent}}% completato",
    "welcomeToast": "Benvenuto su HealthLoop! Il tuo profilo è pronto.",
    "errorAgeRange": "Seleziona la tua fascia d'età",
    "errorCountry": "Seleziona il tuo paese",
    "errorGoal": "Seleziona il tuo obiettivo principale per il benessere",
    "errorCuisine": "Seleziona almeno una preferenza culinaria",
    "errorGeneric": "Impossibile completare la configurazione. Riprova.",
    "step1Title": "Benvenuto su HealthLoop! 👋",
    "step1Subtitle": "Personalizziamo il tuo percorso di salute",
    "ageRangeLabel": "Qual è la tua fascia d'età?",
    "genderLabel": "Genere (Opzionale)",
    "gender_male": "Uomo",
    "gender_female": "Donna",
    "gender_non-binary": "Non binario",
    "gender_prefer_not_to_say": "Preferisco non rispondere",
    "step2Title": "Dove vivi? 🌍",
    "step2Subtitle": "Questo ci aiuta a consigliarti i pasti più adatti a te",
    "countryLabel": "Seleziona il tuo paese",
    "country_uk": "Regno Unito",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "Sudafrica",
    "country_usa": "Stati Uniti",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Giamaica",
    "country_other": "Altro",
    "step3Title": "Qual è il tuo obiettivo principale? 🎯",
    "step3Subtitle": "Scegli il traguardo di benessere che vuoi raggiungere",
    "additionalGoals": "Altri obiettivi? (Opzionale)",
    "goal_weight_loss": "Perdere peso",
    "goalDesc_weight_loss": "In modo sano e bilanciato",
    "goal_weight_maintenance": "Mantenere il peso",
    "goalDesc_weight_maintenance": "Restare al peso attuale",
    "goal_muscle_gain": "Aumentare la massa muscolare",
    "goalDesc_muscle_gain": "Migliorare forza e muscoli",
    "goal_general_wellness": "Benessere generale",
    "goalDesc_general_wellness": "Migliorare la salute complessiva",
    "goal_better_sleep": "Dormire meglio",
    "goalDesc_better_sleep": "Migliorare la qualità del sonno",
    "goal_reduce_stress": "Ridurre lo stress",
    "goalDesc_reduce_stress": "Gestire meglio le tensioni",
    "goal_increase_energy": "Più energia",
    "goalDesc_increase_energy": "Sentirsi più vitali",
    "step4Title": "Preferenze alimentari 🍽️",
    "step4Subtitle": "Scegli le cucine che ami e indica eventuali restrizioni",
    "cuisineLabel": "Cucine preferite",
    "cuisineHint": "Selezionane almeno una (puoi sceglierne più di una)",
    "dietaryLabel": "Restrizioni alimentari (Opzionale)",
    "diet_vegetarian": "Vegetariano",
    "diet_vegan": "Vegano",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Senza glutine",
    "diet_dairy_free": "Senza latticini",
    "diet_pescatarian": "Pescatariano",
    "step5Title": "Condizioni di salute 🏥",
    "step5Subtitle": "Opzionale — ci aiuta a darti consigli migliori",
    "conditionsLabel": "Hai una di queste condizioni?",
    "conditionsHint": "Queste informazioni sono private e servono a personalizzare la tua esperienza",
    "condition_diabetes": "Diabete",
    "condition_hypertension": "Ipertensione",
    "condition_heart_disease": "Malattie cardiache",
    "condition_thyroid": "Problemi alla tiroide",
    "condition_celiac": "Celiachia",
    "condition_ibs": "Sindrome dell'intestino irritabile",
    "condition_none": "Nessuna",
    "privacyTitle": "I tuoi dati sono protetti",
    "privacyBody": "Le tue informazioni personali sono criptate e archiviate in modo sicuro. Utilizziamo questi dati solo per personalizzare la tua esperienza con consigli alimentari su misura, suggerimenti per la salute e notifiche. I tuoi dati non saranno mai condivisi con terze parti senza il tuo consenso esplicito.",
    "trackMedication": "Voglio monitorare i miei farmaci",
    "specialistInterest": "Mi interessano le consulenze specialistiche",
    "welcomeTitle": "Benvenuto su HealthLoop! 👋",
    "welcomeSubtitle": "Personalizziamo la tua intelligenza per la prevenzione e lo stile di vita basata su IA in pochi semplici passaggi",
    "stepLabel": "Passaggio {{current}} di {{total}}",
    "skipForNow": "Salta per ora",
    "skipToast": "Puoi completare la configurazione in qualsiasi momento dal tuo profilo",
    "back": "Indietro",
    "next": "Avanti",
    "completing": "Completamento in corso...",
    "complete": "Configurazione Completa",
    "successToast": "Benvenuto su HealthLoop! Il tuo profilo è ora personalizzato 🎉",
    "failureToast": "Impossibile completare la configurazione",
    "validation": {
      "basicInfo": "Per favore, inserisci tutte le informazioni di base",
      "pickGoal": "Seleziona almeno un obiettivo di benessere",
      "pickPrimary": "Seleziona il tuo obiettivo principale",
      "pickRegion": "Seleziona la tua regione culturale per suggerimenti sui pasti personalizzati",
      "pickFocus": "Seleziona il tuo ambito di benessere principale"
    },
    "step1": {
      "title": "Il Tuo Profilo Benessere",
      "description": "Aiutaci a costruire la tua intelligenza sanitaria IA personalizzata",
      "age": "Età *",
      "agePlaceholder": "es., 30",
      "height": "Altezza (cm) *",
      "heightPlaceholder": "es., 170",
      "weight": "Peso (kg) *",
      "weightPlaceholder": "es., 70"
    },
    "step2": {
      "title": "I Tuoi Obiettivi",
      "description": "Seleziona tutto quello che ti interessa, poi scegli il tuo obiettivo principale",
      "primaryLabel": "Seleziona il Tuo Obiettivo Principale *",
      "primaryBadge": "Principale"
    },
    "step3": {
      "title": "🌍 Cultura e Preferenze Alimentari",
      "description": "Aiutaci a personalizzare i tuoi consigli sui pasti",
      "regionLabel": "Regione Culturale *",
      "regionHint": "Seleziona il tuo background culturale per suggerimenti sui pasti su misura",
      "countryLabel": "Paese (Opzionale)",
      "countryPlaceholder": "es., Nigeria, Kenya, Giamaica",
      "countryHint": "Per raccomandazioni ancora più precise",
      "foodPrefLabel": "Preferenza Diversità Alimentare"
    },
    "step4": {
      "title": "Focus Principale sul Benessere",
      "description": "Scegli l'area su cui vuoi concentrarti maggiormente"
    },
    "step5": {
      "title": "Le Tue Preferenze",
      "description": "Personalizza la tua esperienza con HealthLoop",
      "trackMeds": "Monitora Integratori e Benessere",
      "trackMedsHint": "Abilita il monitoraggio e i promemoria nei tuoi check-in giornalieri",
      "specialist": "Interessato al Supporto di Specialisti",
      "specialistHint": "Accedi a esperti di benessere, nutrizionisti e professionisti della salute mentale",
      "confidentialTitle": "Supporto Riservato:",
      "confidentialBody": "Tutte le tue informazioni sono protette e utilizzate esclusivamente per fornire approfondimenti personalizzati sulla prevenzione."
    },
    "step6": {
      "title": "Personalizzazione Pasti",
      "description": "Aiutaci a consigliarti pasti che corrispondano ai tuoi gusti e alle tue esigenze",
      "cuisinesLabel": "Cucine Preferite (Opzionale)",
      "cuisinesHint": "Seleziona le cucine che preferisci",
      "dietaryLabel": "Restrizioni Alimentari (Opzionale)",
      "dietaryHint": "Seleziona quelle che ti riguardano",
      "allergiesLabel": "Allergie Comuni (Opzionale)",
      "allergiesHint": "Seleziona eventuali allergie alimentari",
      "personalisedTitle": "Pasti Personalizzati:",
      "personalisedBody": "Useremo queste preferenze per suggerirti piatti in linea con i tuoi gusti. Puoi aggiornarle quando vuoi nelle Impostazioni."
    },
    "healthGoals": {
      "better_sleep": "Dormire Meglio",
      "reduce_stress": "Ridurre lo Stress",
      "increase_energy": "Più Energia",
      "weight_management": "Gestione del Peso",
      "improve_fitness": "Migliorare la Forma",
      "better_nutrition": "Nutrizione Ottimale",
      "mental_wellness": "Benessere Mentale",
      "chronic_condition": "Gestione Benessere Preventivo"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Salute Mentale",
        "description": "Focus su umore, stress e benessere emotivo"
      },
      "physical_fitness": {
        "label": "Forma Fisica",
        "description": "Focus su esercizio, forza e attività"
      },
      "nutrition": {
        "label": "Nutrizione",
        "description": "Focus su dieta, pasti e alimentazione sana"
      },
      "sleep": {
        "label": "Qualità del Sonno",
        "description": "Focus su riposo, ritmi del sonno e recupero"
      },
      "stress_management": {
        "label": "Gestione dello Stress",
        "description": "Focus su relax e riduzione della tensione"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Africa Occidentale",
        "description": "Cucina nigeriana, ghanese, senegalese"
      },
      "east_african": {
        "label": "Africa Orientale",
        "description": "Cucina keniota, etiope, tanzaniana"
      },
      "north_african": {
        "label": "Nord Africa",
        "description": "Cucina marocchina, egiziana"
      },
      "southern_african": {
        "label": "Africa del Sud",
        "description": "Cucina sudafricana"
      },
      "caribbean": {
        "label": "Caraibica",
        "description": "Cucina giamaicana, di Trinidad e Barbados"
      },
      "middle_eastern": {
        "label": "Medio Oriente",
        "description": "Cucina libanese, palestinese, siriana"
      },
      "south_asian": {
        "label": "Asia Meridionale",
        "description": "Cucina indiana, pakistana, bengalese"
      },
      "east_asian": {
        "label": "Asia Orientale",
        "description": "Cucina cinese, giapponese, coreana"
      },
      "southeast_asian": {
        "label": "Sud-est Asiatico",
        "description": "Cucina thailandese, vietnamita, indonesiana"
      },
      "western": {
        "label": "Occidentale",
        "description": "Cucina americana, europea"
      },
      "latin_american": {
        "label": "America Latina",
        "description": "Cucina messicana, brasiliana, argentina"
      },
      "mediterranean": {
        "label": "Mediterranea",
        "description": "Cucina greca, italiana, spagnola"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Tradizionale",
        "description": "Principalmente pasti della tua regione culturale"
      },
      "mixed": {
        "label": "Misto",
        "description": "Equilibrio tra cucina locale e internazionale"
      },
      "international": {
        "label": "Internazionale",
        "description": "Diverse cucine dal mondo"
      }
    },
    "cuisines": {
      "west_african": "Africa Occidentale",
      "caribbean": "Caraibica",
      "mediterranean": "Mediterranea",
      "asian": "Asiatica",
      "western": "Occidentale",
      "indian": "Indiana",
      "middle_eastern": "Mediorientale",
      "general": "Tutte le Cucine"
    },
    "dietary": {
      "vegetarian": "Vegetariano",
      "vegan": "Vegano",
      "pescatarian": "Pescetariano",
      "gluten_free": "Senza Glutine",
      "dairy_free": "Senza Lattosio",
      "low_carb": "Low-Carb"
    },
    "allergies": {
      "nuts": "Frutta a guscio",
      "shellfish": "Crostacei",
      "dairy": "Latticini",
      "eggs": "Uova",
      "soy": "Soia",
      "gluten": "Glutine"
    },
    "cuisine_nigerian": "Nigeriana",
    "cuisine_ghanaian": "Ghanese",
    "cuisine_senegalese": "Senegalese",
    "cuisine_kenyan": "Keniana",
    "cuisine_ethiopian": "Etiope",
    "cuisine_moroccan": "Marocchina",
    "cuisine_south_african": "Sudafricana",
    "cuisine_jamaican": "Giamaicana",
    "cuisine_trinidadian": "Trinidadiana",
    "cuisine_lebanese": "Libanese",
    "cuisine_turkish": "Turca",
    "cuisine_greek": "Greca",
    "cuisine_italian": "Italiana",
    "cuisine_french": "Francese",
    "cuisine_british": "Britannica",
    "cuisine_indian_south": "Dell'India del sud",
    "cuisine_indian_north": "Dell'India del nord",
    "cuisine_pakistani": "Pakistana",
    "cuisine_japanese": "Giapponese",
    "cuisine_chinese": "Cinese",
    "cuisine_korean": "Coreana",
    "cuisine_vietnamese": "Vietnamita",
    "cuisine_thai": "Thailandese",
    "cuisine_filipino": "Filippina",
    "cuisine_american": "Americana",
    "cuisine_mexican": "Messicana",
    "cuisine_brazilian": "Brasiliana",
    "cuisine_peruvian": "Peruviana"
  },
  "dashboard": {
    "welcome": "Bentornato",
    "greeting": "Ciao",
    "goodMorning": "Buongiorno",
    "goodAfternoon": "Buon pomeriggio",
    "goodEvening": "Buonasera",
    "tagline": "Piccoli passi sani portano a cambiamenti duraturi",
    "microcopy": "Il tuo percorso verso il benessere è importante.",
    "welcomeSubtitleMorning1": "Un inizio di giornata sereno.",
    "welcomeSubtitleMorning2": "Felici di vederti stamattina.",
    "welcomeSubtitleMorning3": "Ogni piccolo momento conta.",
    "welcomeSubtitleAfternoon1": "Speriamo che la tua giornata proceda bene.",
    "welcomeSubtitleAfternoon2": "Bentornato su HealthLoop.",
    "welcomeSubtitleAfternoon3": "Fai un respiro profondo — stai andando bene.",
    "welcomeSubtitleEvening1": "Rilassiamoci insieme.",
    "welcomeSubtitleEvening2": "Per concludere la giornata in dolcezza.",
    "welcomeSubtitleEvening3": "Bentornato stasera.",
    "title": "La tua piattaforma di intelligenza per la prevenzione",
    "subtitle": "Monitora, impara e agisci prima che insorgano problemi",
    "summary": "Riepilogo della tua salute",
    "summaryDesc": "Analisi in tempo reale su prevenzione, educazione, coinvolgimento e benessere",
    "comprehensiveSupport": "Supporto completo per prevenzione, formazione, partecipazione e benessere",
    "todayCheckIn": "Check-in di oggi",
    "quickActions": "Azioni rapide",
    "healthOverview": "Panoramica salute",
    "recentActivity": "Attività recente",
    "viewAll": "Vedi tutto",
    "preventiveHealth": "Prevenzione",
    "preventiveHealthDesc": "Monitoraggio quotidiano, controllo del benessere e avvisi preventivi",
    "education": "Formazione",
    "educationDesc": "Approfondimenti scientifici, articoli sulla salute e guida esperta",
    "engagement": "Coinvolgimento",
    "engagementDesc": "Sfide della community, monitoraggio abitudini e supporto sociale",
    "wellness": "Benessere",
    "wellnessDesc": "Nutrizione smart, equilibrio nello stile di vita e benessere olistico",
    "todaysInsight": "Consiglio del giorno",
    "wellnessScore": "Punteggio Benessere",
    "healthStreak": "Frequenza salute",
    "days": "giorni",
    "logHealth": "Registra salute",
    "getEducated": "Impara",
    "communityChallenge": "Sfida community",
    "checkWellness": "Controlla benessere",
    "verified": "Verificato",
    "joinCommunity": "Unisciti alla community",
    "personalizedPlan": "Piano personalizzato",
    "score": "Punteggio",
    "checkIns": "check-in",
    "habits": "abitudini",
    "preventive": "Preventivo",
    "healthMetrics": "Parametri salute",
    "trackMetrics": "Monitora parametri",
    "startTracking": "Inizia a monitorare",
    "logMetrics": "Registra parametri",
    "dailyInsight": "Analisi quotidiana",
    "learnAbout": "Scopri oggi la prevenzione",
    "articlesAvailable": "articoli disponibili",
    "browseArticles": "Sfoglia articoli",
    "currentStreak": "Serie attuale",
    "keepGoing": "Continua così!",
    "startStreak": "Inizia la tua serie",
    "checkIn": "Check-in",
    "nutritionPlan": "Piano nutrizionale",
    "mealsPlanned": "pasti pianificati",
    "viewPlan": "Vedi piano",
    "planYourWeek": "Pianifica la settimana",
    "moodStress": "Umore e Stress",
    "howFeeling": "Come ti senti?",
    "logWellness": "Registra benessere",
    "medications": "Farmaci",
    "noMeds": "Nessun farmaco inserito",
    "addMedications": "Aggiungi i tuoi farmaci",
    "daysTracked": "Giorni monitorati",
    "noHabits": "Ancora nessuna abitudine",
    "startTrackingHabits": "Inizia a seguire le tue abitudini",
    "insights": "Analisi",
    "noInsights": "Ancora nessuna analisi",
    "completeFirstPlan": "Completa il tuo primo piano",
    "noCheckIns": "Ancora nessun check-in",
    "startFirstCheckIn": "Fai il tuo primo check-in"
  },
  "support": {
    "title": "Assistenza",
    "subtitle": "Trova risposte, contattaci o segnala un problema",
    "backToSettings": "Torna alle impostazioni",
    "privacyBanner": "Le richieste di assistenza sono gestite in modo privato e sicuro. I tuoi dati sulla salute restano riservati.",
    "section1": "Sezione 1",
    "section2": "Sezione 2",
    "section3": "Sezione 3",
    "section4": "Sezione 4",
    "navHelpCenter": "Centro assistenza",
    "navContact": "Contatta l'assistenza",
    "navHealth": "Servizi per la salute",
    "navTechnical": "Supporto tecnico",
    "helpCenterTitle": "Centro assistenza",
    "helpCenterSubtitle": "Cerca tra le domande comuni e trova risposte rapide.",
    "contactTitle": "Contatta l'assistenza",
    "contactSubtitle": "Contatta il nostro team attraverso il canale che preferisci.",
    "healthServicesTitle": "Servizi per la salute",
    "healthServicesSubtitle": "Collegati al monitoraggio farmaci e agli esperti clinici.",
    "technicalTitle": "Supporto tecnico",
    "technicalSubtitle": "Segnala bug o problemi tecnici con i dettagli necessari.",
    "searchPlaceholder": "Cerca domande comuni…",
    "liveChat": "Chat dal vivo",
    "emailUs": "Inviaci un'email",
    "callBack": "Prenota una chiamata",
    "sendMessage": "Invia un messaggio",
    "medicationTracking": "Monitoraggio farmaci",
    "specialistAccess": "Accesso specialisti",
    "videoConsultation": "Consulto video",
    "reportBug": "Segnala un bug",
    "yourName": "Il tuo nome",
    "yourEmail": "La tua email",
    "subject": "Oggetto",
    "message": "Messaggio",
    "phone": "Telefono",
    "description": "Descrizione",
    "submit": "Invia",
    "successTitle": "Messaggio inviato",
    "successDescription": "Ti risponderemo entro 24–48 ore.",
    "healthDisclaimer": "In caso di emergenza medica, contatta i servizi di pronto soccorso locali. HealthLoop non sostituisce il parere di un medico professionista."
  },
  "nutrition": {
    "smartNutrition": "Alimentazione Smart",
    "basedOnGoal": "In base al tuo obiettivo:",
    "personalizedData": "Personalizzato in base ai tuoi dati sanitari recenti",
    "evidenceBased": "Nutrizione basata su prove scientifiche per il tuo piano di prevenzione",
    "todaysMealSuggestions": "Consigli per i pasti di oggi",
    "customize": "Personalizza",
    "breakfast": "Colazione",
    "lunch": "Pranzo",
    "dinner": "Cena",
    "loadingBreakfast": "Caricamento colazione...",
    "loadingLunch": "Caricamento pranzo...",
    "loadingDinner": "Caricamento cena...",
    "cal": "kcal",
    "protein": "proteine",
    "swapMeal": "Cambia pasto",
    "healthyOptionsNearYou": "Opzioni sane vicino a te",
    "enableLocation": "Attiva posizione",
    "view": "Vedi",
    "discoverOptions": "Scopri ristoranti salutari, negozi di alimentari e fornitori di pasti pronti vicino a te",
    "cuisinesSelected": "cucine selezionate",
    "cuisineSelected": "cucina selezionata",
    "dietaryPrefs": "pref. alimentari",
    "dietaryPref": "pref. alimentare",
    "customizeMeals": "Personalizza pasti",
    "subtitleAdaptive": "Pianificazione pasti personalizzata e culturalmente adatta ai tuoi obiettivi di salute",
    "hideFavorites": "Nascondi preferiti",
    "viewFavorites": "Vedi preferiti",
    "customizeMealsLegacy": "Personalizza i pasti in base alle tue preferenze culturali e necessità alimentari",
    "viewFullPlan": "Vedi piano completo",
    "exploreRecipes": "Esplora ricette"
  },
  "location": {
    "permissionTitle": "Trova opzioni sane vicino a te",
    "permissionDesc": "Utilizzato per consigliarti ristoranti, negozi e servizi di pasti pronti in linea con i tuoi obiettivi di salute.",
    "howToEnable": "Come attivare:",
    "step1": "Clicca sull'icona del lucchetto 🔒 nella barra degli indirizzi del browser",
    "step2": "Trova i permessi \"Posizione\"",
    "step3": "Seleziona \"Consenti\"",
    "step4": "Aggiorna questa pagina",
    "refreshPage": "Aggiorna pagina",
    "allowLocation": "Consenti posizione",
    "notNow": "Non ora",
    "denied": "L'accesso alla posizione è stato bloccato. Per vedere le opzioni sane nelle vicinanze, devi attivare i permessi di localizzazione.",
    "unavailable": "Informazioni sulla posizione attualmente non disponibili. Controlla le impostazioni del dispositivo.",
    "error": "Impossibile accedere alla tua posizione. Riprova o controlla le impostazioni del browser.",
    "unsupported": "Il tuo browser non supporta i servizi di localizzazione. Prova a usare un browser moderno come Chrome, Firefox o Safari.",
    "accessRequired": "Accesso alla posizione richiesto"
  },
  "womensHealth": {
    "title": "Salute Donna",
    "description": "Monitora il tuo ciclo, registra i sintomi e ricevi consigli di benessere personalizzati in base alla tua fase ormonale",
    "cycleTracking": "Monitoraggio ciclo",
    "symptomLogging": "Registro sintomi",
    "phaseInsights": "Analisi della fase",
    "logPeriod": "Registra ciclo",
    "logSymptoms": "Registra sintomi",
    "insights": "Analisi",
    "tips": "Consigli salute",
    "overview": "Panoramica",
    "history": "Cronologia",
    "startTracking": "Inizia a monitorare il ciclo"
  },
  "profile": {
    "title": "Profilo",
    "personalInfo": "Informazioni personali",
    "healthProfile": "Profilo salute",
    "preferences": "Preferenze",
    "language": "Lingua",
    "selectLanguage": "Seleziona lingua",
    "notifications": "Notifiche",
    "privacy": "Privacy",
    "security": "Sicurezza",
    "quickAccess": "Accesso rapido",
    "editProfile": "Modifica profilo",
    "viewStats": "Vedi statistiche",
    "backToDashboard": "Torna alla Home",
    "womensHealthTitle": "Salute Donna",
    "womensHealthDesc": "Monitoraggio ciclo, sintomi e consigli di benessere",
    "healthRemindersTitle": "Promemoria salute",
    "healthRemindersDesc": "Gestisci le tue notifiche",
    "manageRemindersDesc": "Gestisci le preferenze per i promemoria e le notifiche",
    "healthPatternAlerts": "Avvisi sulle tendenze della salute",
    "supportHelp": "Supporto e Aiuto",
    "supportHelpDesc": "Ricevi assistenza, segnala problemi o consulta le FAQ",
    "admin": "Admin",
    "adminDesc": "Vedi metriche di utilizzo e analisi sul comportamento degli utenti",
    "giveFeedback": "Invia feedback",
    "giveFeedbackDesc": "Condividi la tua esperienza con HealthLoop",
    "reportProblem": "Segnala un problema",
    "reportProblemDesc": "Aiutaci a correggere bug e migliorare l'app",
    "manageHealthInfo": "Gestisci le tue informazioni di prevenzione per analisi personalizzate",
    "basicInformation": "Informazioni di base",
    "fullName": "Nome e cognome",
    "email": "Email",
    "dateOfBirth": "Data di nascita",
    "gender": "Genere",
    "height": "Altezza (cm)",
    "weight": "Peso (kg)",
    "medicalConditions": "Condizioni di salute",
    "allergies": "Allergie",
    "personalHealth": "Salute personale",
    "addCondition": "Aggiungi una condizione di salute",
    "addAllergy": "Aggiungi un'allergia",
    "saveChanges": "Salva modifiche",
    "saving": "Salvataggio...",
    "privacyMessage": "I tuoi dati sanitari sono protetti secondo standard di riservatezza elevati"
  },
  "settings": {
    "title": "Impostazioni",
    "general": "Generale",
    "account": "Account",
    "appearance": "Aspetto",
    "languageSettings": "Impostazioni lingua",
    "changeLanguage": "Cambia lingua",
    "languageNote": "L'interfaccia si aggiorna nel momento in cui selezioni una nuova lingua. Le lingue africane e quelle aggiunte di recente sono contrassegnate come Starter: tradotte automaticamente per ampliare l'offerta, in attesa di revisione da parte di un madrelingua.",
    "languageUpdated": "Lingua aggiornata con successo",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Traduzione automatica — revisione da parte di un madrelingua in corso.",
    "regions": {
      "global": "Globale",
      "european": "Lingue europee",
      "middleEastern": "Lingue mediorientali",
      "asian": "Lingue asiatiche",
      "african": "Lingue africane"
    }
  },
  "search": {
    "triggerLabel": "Cerca in HealthLoop",
    "triggerHint": "Prova \"passi\", \"farmacia\" o \"gravidanza\"",
    "triggerAriaLabel": "Apri ricerca globale",
    "placeholder": "Cerca funzioni, tracker, supporto…",
    "inputAriaLabel": "Cerca funzioni di HealthLoop",
    "modalAriaLabel": "Cerca in HealthLoop",
    "close": "Chiudi",
    "clear": "Cancella",
    "clearAriaLabel": "Cancella ricerca",
    "recentSearches": "Ricerche recenti",
    "tryFor": "Prova a cercare",
    "findFeatures": "Trova qualsiasi funzione in pochi secondi.",
    "searchAcross": "Cerca in",
    "and": "e",
    "sections": {
      "home": "Home",
      "nutrition": "Nutrizione",
      "family": "Famiglia",
      "services": "Servizi",
      "support": "Supporto",
      "profile": "Profilo"
    },
    "noMatchesFor": "Nessun risultato per \"{{query}}\"",
    "trySimpler": "Prova una parola più semplice come passi, nutrizione o specialista.",
    "comingSoonBadge": "In arrivo",
    "escToClose": "per chiudere",
    "resultSingular": "{{count}} risultato",
    "resultPlural": "{{count}} risultati",
    "searchAcrossApp": "Cerca in tutta l'app"
  },
  "familyMember": {
    "confirmRemove": "Rimuovere {{name}} dal monitoraggio salute familiare?",
    "removed": "{{name}} rimosso/a dalla famiglia",
    "removeFailed": "Impossibile rimuovere il membro",
    "viewDetails": "Visualizza dettagli",
    "edit": "Modifica",
    "remove": "Rimuovi",
    "yearsSuffix": "anni",
    "healthGoalsLabel": "Obiettivi di salute:",
    "moreSuffix": "altro",
    "activeInsights": "Analisi attive",
    "viewAllInsights": "Vedi tutte le {{count}} analisi →",
    "viewFullProfile": "Vedi profilo salute completo",
    "lifeStage": {
      "infant": "Neonato (0-2)",
      "toddler": "Bambino piccolo (2-5)",
      "child": "Bambino (6-12)",
      "adolescent": "Adolescente (13-17)",
      "adult": "Adulto (18-59)",
      "senior": "Senior (60+)",
      "unknown": "Sconosciuto"
    }
  },
  "profileDeep": {
    "backToDashboard": "Torna alla bacheca",
    "profileCompletion": "Completamento profilo",
    "healthSummary": "Riepilogo benessere",
    "sectionA": "Sezione A",
    "sectionB": "Sezione B",
    "sectionC": "Sezione C",
    "sectionD": "Sezione D",
    "personalDetails": "Dettagli personali",
    "healthInformation": "Informazioni sul benessere",
    "accountSettings": "Impostazioni account",
    "fullName": "Nome completo",
    "email": "Email",
    "dob": "Data di nascita",
    "gender": "Genere",
    "genderPlaceholder": "es. Donna, Uomo, Non binario",
    "height": "Altezza (cm)",
    "heightPlaceholder": "es. 170",
    "weight": "Peso (kg)",
    "weightPlaceholder": "es. 70",
    "allergies": "Allergie",
    "allergiesPlaceholder": "es. Arachidi",
    "medicalConditions": "Condizioni di salute",
    "conditionsPlaceholder": "es. Ipertensione",
    "medications": "Farmaci",
    "medicationsPlaceholder": "es. Lisinopril 10mg, quotidiano",
    "emergencyContact": "Contatto di emergenza",
    "emergencyOptional": "(opzionale)",
    "emergencyPlaceholder": "es. Mamma +39 333 0000000",
    "emergencyNote": "Incluso nella condivisione con lo specialista solo se acconsenti.",
    "saveChanges": "Salva modifiche",
    "saving": "Salvataggio in corso…",
    "editProfile": "Modifica profilo",
    "cancelEditing": "Annulla modifica",
    "healthScore": "Punteggio benessere",
    "streak": "Serie",
    "streakDays": "{{n}} giorni",
    "memberSince": "Iscritto dal",
    "remindersActive": "Promemoria attivi",
    "conditionsTracked": "Condizioni monitorate",
    "nextAgenda": "Prossimo impegno",
    "notificationsReminders": "Notifiche e promemoria",
    "notificationsRemindersDesc": "Gestisci orari e canali dei promemoria per la salute",
    "emailNudges": "Incentivi via email",
    "emailNudgesDesc": "Promemoria gentili e riepiloghi settimanali",
    "on": "Attivo",
    "paused": "In pausa",
    "privacySecurity": "Privacy e sicurezza",
    "privacySecurityDesc": "Aggiorna la tua password per proteggere l'account",
    "preferencesTitle": "Preferenze",
    "preferencesDesc": "Lingua, regione e personalizzazione",
    "supportHelp": "Supporto e aiuto",
    "supportHelpDesc": "Trova risposte e contattaci",
    "giveFeedback": "Invia feedback",
    "giveFeedbackDesc": "Dicci cosa migliorare",
    "reportProblem": "Segnala un problema",
    "reportProblemDesc": "Hai trovato un bug? Faccelo sapere",
    "adminInsights": "Analisi amministratore",
    "adminInsightsDesc": "Statistiche di coinvolgimento",
    "adminBadge": "Admin",
    "shareWithClinician": "Condividi con uno specialista",
    "shareWithClinicianDesc": "Riepilogo in sola lettura · scade automaticamente · revocabile in ogni momento",
    "share": "Condividi",
    "profileMayBeOutOfDate": "Il profilo potrebbe non essere aggiornato",
    "profileMayBeOutOfDateDesc": "Mantieni accurati i tuoi dati per ricevere indicazioni più precise — anche piccoli cambiamenti (peso, farmaci) ci aiutano a personalizzare i tuoi suggerimenti.",
    "updateNow": "Aggiorna ora",
    "profileUpdateError": "Impossibile aggiornare la preferenza. Riprova.",
    "healthLoopUser": "Utente HealthLoop",
    "updatedLabel": "Aggiornato",
    "noEntries": "Nessuna voce presente.",
    "completionComplete": "Il tuo profilo è completo. Possiamo offrirti la nostra migliore guida. 💚",
    "completionAlmostThere": "Quasi fatto. Qualche altro dettaglio per sbloccare analisi più precise.",
    "completionInProgress": "Completa il tuo profilo per sbloccare migliori approfondimenti sul benessere.",
    "justNow": "proprio ora",
    "minAgo": "{{n}} min fa",
    "minsAgo": "{{n}} min fa",
    "hourAgo": "{{n}} ora fa",
    "hoursAgo": "{{n}} ore fa",
    "dayAgo": "{{n}} giorno fa",
    "daysAgo": "{{n}} giorni fa",
    "checkinDueToday": "Check-in previsto per oggi",
    "checkinDueTonight": "Check-in previsto per stasera"
  },
  "supportDeep": {
    "backToSettings": "Torna alle impostazioni",
    "quickNavAria": "Sezioni di supporto",
    "searchPlaceholder": "Cerca aiuto…",
    "searchAria": "Cerca nelle domande frequenti",
    "resultsCount": "{{n}} risultato",
    "resultsCountPlural": "{{n}} risultati",
    "questionsCount": "{{n}} domande",
    "liveChatTitle": "Chat dal vivo",
    "liveChatDesc": "Parla con noi in tempo reale · Lun–Ven 9:00–18:00",
    "startChat": "Inizia Chat",
    "liveChatSoonToast": "La chat dal vivo sarà disponibile a breve. Nel frattempo, puoi scriverci via email.",
    "emailUsTitle": "Scrivici una email",
    "emailUsDesc": "Risposta entro 24–48 ore",
    "copy": "Copia",
    "emailCopied": "Email copiata negli appunti.",
    "contactFormTitle": "Modulo di contatto",
    "contactFormDesc": "Inviaci un messaggio — risponderemo via email.",
    "yourNameLabel": "Il tuo nome *",
    "namePlaceholder": "Maria Rossi",
    "yourEmailLabel": "La tua email *",
    "emailPlaceholder": "maria@esempio.it",
    "subjectOptional": "Oggetto (opzionale)",
    "subjectPlaceholder": "Come possiamo aiutarti?",
    "messageLabel": "Messaggio *",
    "messagePlaceholder": "Descrivi brevemente di cosa hai bisogno.",
    "sending": "Invio in corso…",
    "sendMessage": "Invia Messaggio",
    "messageSent": "Messaggio inviato",
    "messageSentDesc": "Risponderemo entro 24–48 ore.",
    "callbackTitle": "Richiedi di essere ricontattato",
    "callbackDesc": "Ti richiameremo all'orario che preferisci.",
    "phoneLabel": "Numero di telefono *",
    "phonePlaceholder": "+39 012 345 6789",
    "preferredTimeLabel": "Orario preferito (opzionale)",
    "preferredTimePlaceholder": "es. domani pomeriggio",
    "reasonLabel": "Motivo (opzionale)",
    "reasonPlaceholder": "Di cosa vorresti parlare?",
    "submitting": "Invio in corso…",
    "requestCallback": "Richiedi chiamata",
    "callbackRequested": "Chiamata richiesta",
    "callbackRequestedDesc": "Ti contatteremo entro 24 ore.",
    "medicationSupport": "Supporto farmaci",
    "medicationSupportDesc": "Monitora prescrizioni, ricariche e promemoria.",
    "goToMedications": "Vai ai farmaci →",
    "specialistConsultation": "Consulenza specialistica",
    "specialistConsultationDesc": "Connettiti con un professionista per una guida personalizzata.",
    "connectExpert": "Parla con un esperto →",
    "videoConsult": "Video consulto",
    "videoConsultDesc": "Prenota una sessione video con uno specialista.",
    "bookConsultation": "Prenota consulto →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop supporta il tuo benessere quotidiano — non sostituisce le cure mediche di emergenza. In caso di urgenza, contatta i servizi di soccorso locali.",
    "categoryLabel": "Categoria",
    "catBug": "Bug / Errore",
    "catPerformance": "Lentezza dell'app",
    "catFeature": "Funzione non funzionante",
    "catUi": "Problema di visualizzazione",
    "catOther": "Altro",
    "issueTitle": "Titolo del problema *",
    "issueTitlePlaceholder": "Breve riepilogo",
    "detailedDescription": "Descrizione dettagliata *",
    "detailedDescriptionPlaceholder": "Cosa è successo? Cosa stavi facendo? I passaggi per riprodurre l'errore ci sono molto utili.",
    "autoAttachNote": "Le info su dispositivo, browser e schermo sono allegate automaticamente.",
    "submitReport": "Invia segnalazione",
    "reportSubmitted": "Segnalazione inviata",
    "reportSubmittedDesc": "Il nostro team se ne sta occupando.",
    "fillAllFields": "Per favore compila tutti i campi obbligatori",
    "problemReportSubmittedToast": "Segnalazione inviata. Indagheremo e ti risponderemo presto.",
    "messageSentToast": "Messaggio inviato. Risponderemo entro 24–48 ore.",
    "callRequestedToast": "Richiesta di chiamata ricevuta. Ti contatteremo entro 24 ore.",
    "submitFailGeneric": "Invio fallito. Riprova o scrivi a {{email}}.",
    "submitFailContact": "Impossibile inviare. Scrivi direttamente a {{email}}.",
    "comingSoon": "Prossimamente",
    "specialistRoadmapTitle": "Parla con uno specialista",
    "specialistRoadmapSubtitle": "Il supporto umano è in arrivo. Queste funzioni saranno qui, a portata di tocco.",
    "talkToSpecialistTitle": "Parla con uno specialista",
    "talkToSpecialistDesc": "Chat in tempo reale con professionisti per le tue domande quotidiane sul benessere.",
    "bookSpecialistTitle": "Prenota uno specialista",
    "bookSpecialistDesc": "Pianifica una sessione 1:1 con lo specialista più adatto ai tuoi obiettivi.",
    "liveHealthGuidanceTitle": "Guida al benessere dal vivo",
    "liveHealthGuidanceDesc": "Supporto video per sintomi, risultati di analisi o piani di benessere.",
    "mentalWellnessTitle": "Supporto per il benessere mentale",
    "mentalWellnessDesc": "Supporto confidenziale da parte di professionisti quando la vita si fa pesante.",
    "wellnessNavigationTitle": "Navigazione del benessere",
    "wellnessNavigationDesc": "Un percorso guidato per aiutarti a scegliere il prossimo passo giusto per te.",
    "pharmacyRoadmapTitle": "Supporto farmaci e farmacia",
    "pharmacyRoadmapSubtitle": "L'aiuto relativo ai farmaci si trova qui, senza schede extra da imparare.",
    "medicationGuidanceTitle": "Guida ai farmaci",
    "medicationGuidanceDesc": "Informazioni chiare su dosaggi, orari e interazioni comuni.",
    "findNearbyPharmacyTitle": "Trova farmacie vicine",
    "findNearbyPharmacyDesc": "Localizza rapidamente farmacie fidate nella tua zona quando hai bisogno di una ricarica.",
    "refillReminderTitle": "Promemoria ricarica farmaci",
    "refillReminderDesc": "Promemoria gentili per non restare mai senza i tuoi farmaci importanti.",
    "otcWellnessTitle": "Consigli sui prodotti da banco",
    "otcWellnessDesc": "Guida curata su opzioni sicure e basate su evidenze scientifiche."
  },
  "careServices": {
    "pageTitle": "Servizi di assistenza",
    "pageSubtitle": "Supporto clinico e di benessere pensato per il tuo percorso quotidiano.",
    "specialistCareTitle": "Cure specialistiche",
    "specialistCareSubtitle": "Parla con professionisti e prenota lo specialista giusto quando ne hai bisogno.",
    "medicationPharmacyTitle": "Farmaci e Farmacia",
    "medicationPharmacySubtitle": "Guida ai farmaci in linguaggio semplice e aiuto con la farmacia.",
    "wellnessSupportTitle": "Supporto Benessere",
    "wellnessSupportSubtitle": "Benessere mentale, consigli sui prodotti da banco e percorsi chiari.",
    "futureWellnessTitle": "Funzioni future",
    "futureWellnessSubtitle": "Un'anteprima di ciò che è previsto nel piano di HealthLoop per il benessere preventivo.",
    "futureFeatureBadge": "Funzione futura",
    "futurePersonalizedMealsTitle": "Piani alimentari personalizzati",
    "futurePersonalizedMealsDesc": "Piani pasti orientati al benessere, adattati ai tuoi obiettivi, allergie e cultura.",
    "futureHealthyDeliveryTitle": "Consegna pasti sani",
    "futureHealthyDeliveryDesc": "Consegne curate da cucine e partner attenti alla salute.",
    "futureFarmFreshTitle": "Alimenti freschi di fattoria",
    "futureFarmFreshDesc": "Accesso diretto ad aziende agricole locali e partner di prodotti freschi stagionali.",
    "futureFoodPartnershipsTitle": "Partnership per l'alimentazione",
    "futureFoodPartnershipsDesc": "Relazioni curate con gastronomie sane, alimentari e marchi di benessere.",
    "futureNutritionCoachingTitle": "Coaching nutrizionale",
    "futureNutritionCoachingDesc": "Guida individuale da parte di coach nutrizionali qualificati.",
    "futureFamilyWellnessTitle": "Piani di benessere familiare",
    "futureFamilyWellnessDesc": "Piani condivisi per mantenere in salute tutta la famiglia.",
    "futureWellnessPlusTitle": "Abbonamento Wellness+",
    "futureWellnessPlusDesc": "Un livello premium per guida personalizzata, supporto prioritario e analisi approfondite.",
    "futurePharmacyPartnersTitle": "Partnership con farmacie",
    "futurePharmacyPartnersDesc": "Connessioni con farmacie fidate per indicazioni sui farmaci e ricariche.",
    "futureAdvancedSpecialistTitle": "Cure specialistiche avanzate",
    "futureAdvancedSpecialistDesc": "Accesso coordinato a specialisti, secondi pareri e navigazione dell'assistenza.",
    "futureWellnessMarketplaceTitle": "Marketplace del benessere",
    "futureWellnessMarketplaceDesc": "Un mercato curato di prodotti e servizi per il benessere verificati.",
    "futureVendorCollabTitle": "Sistemi di collaborazione fornitori",
    "futureVendorCollabDesc": "Sistemi di inserimento e qualità per partner di cibo sano e benessere."
  },
  "dashboardDeep": {
    "healthProfile": "Profilo benessere",
    "notifications": "Notifiche",
    "familyAccounts": "Account famiglia",
    "settings": "Impostazioni",
    "logout": "Esci",
    "allCaughtUp": "Sei in pari con tutto.",
    "weekInReview": "Il riepilogo della tua settimana",
    "dismissNotification": "Ignora notifica",
    "dismissWeeklyDigest": "Ignora riepilogo settimanale",
    "notificationsAria": "Notifiche",
    "profileMenuAria": "Apri menu profilo",
    "loadingWellness": "Caricamento del riepilogo benessere",
    "nextTip": "Prossimo consiglio",
    "todayAtGlance": "Oggi in breve",
    "healthScoreLabel": "Punteggio Benessere",
    "currentStreakLabel": "Serie attuale",
    "todaysProgress": "Progressi di oggi",
    "insightForYou": "Un'analisi per te",
    "checkMyHealthRisk": "Controlla il mio rischio salute",
    "quickAccess": "Accesso rapido",
    "exploreCareServicesTitle": "Esplora i servizi",
    "exploreCareServicesSubtitle": "Specialisti · farmacia · benessere — tutto in un unico posto.",
    "familyCare": "Cura della famiglia",
    "healthLibrary": "Biblioteca salute",
    "myHealthData": "I miei dati",
    "askQuestion": "Fai una domanda",
    "dashLoadError": "Impossibile caricare la bacheca. Riprova.",
    "taskUpdateError": "Impossibile aggiornare l'attività. Riprova.",
    "perfectDay": "Giorno perfetto! 🎉 Serie prolungata.",
    "letsStart": "Iniziamo",
    "yourNextStepToday": "Il tuo prossimo passo oggi",
    "completeDailyCheck": "Completa il controllo quotidiano",
    "startDailyCheck": "Inizia controllo",
    "viewAll": "Vedi tutto",
    "graceProtected": "Giorno di tolleranza attivo",
    "todaysHealthRecommendations": "Raccomandazioni di oggi",
    "updateViaCheck": "Aggiorna tramite controllo giornaliero",
    "healthInsight": "Analisi benessere",
    "riskCheckSubtext": "Ottieni analisi personalizzate in pochi secondi",
    "foodDiet": "Alimentazione e dieta",
    "healthScoreNew": "Punteggio Benessere · Nuovo",
    "letsBuildScore": "Costruiamo insieme il tuo punteggio",
    "oneHealthyHabitAtATime": "Una sana abitudine alla volta.",
    "nextCheck": "Prossimo controllo:",
    "todayAt8pm": "oggi alle 20:00",
    "wellnessTipForYou": "Consiglio del giorno · Per te",
    "wellnessTipForFactor": "Consiglio del giorno · Per il tuo fattore {{factor}}",
    "logged": "Registrato",
    "gotIt": "Capito 👍",
    "gladToSeeYou": "Siamo felici di vederti oggi 💚",
    "takesLessThan60Sec": "Richiede meno di 60 secondi",
    "scoreReadyWhenYou": "Pronto quando lo sei tu",
    "scoreCompleteFirstCheck": "Completa il primo controllo benessere per sbloccare analisi personalizzate.",
    "scoreExcellent": "Eccellente",
    "scoreSupportExcellent": "Sei in forma smagliante oggi. Continua così.",
    "scoreGood": "Buono",
    "scoreSupportGood": "Stai andando bene. Mantieni le tue sane abitudini.",
    "scoreModerate": "Moderato",
    "scoreSupportModerate": "Stai andando discretamente, ma alcune aree richiedono attenzione.",
    "scoreNeedsAttention": "Richiede attenzione",
    "scoreSupportNeedsAttention": "Il tuo benessere richiede attenzione oggi. Piccoli cambiamenti possono aiutare a migliorare."
  },
  "emailVerify": {
    "bannerWithEmail": "Per favore verifica la tua email ({{email}}) per proteggere il tuo account e ricevere i suggerimenti quotidiani.",
    "bannerNoEmail": "Per favore verifica la tua email per proteggere il tuo account e ricevere i suggerimenti quotidiani.",
    "sending": "Invio in corso…",
    "resend": "Reinvia email",
    "sentToast": "Email di verifica inviata. Controlla la tua posta in arrivo.",
    "sendFailToast": "Impossibile inviare l'email di verifica. Riprova più tardi."
  },
  "forgotPassword": {
    "title": "Password dimenticata?",
    "subtitle": "Nessun problema! Inserisci la tua email e ti invieremo le istruzioni per il ripristino.",
    "emailLabel": "Indirizzo Email",
    "emailPlaceholder": "tua.email@esempio.it",
    "sendResetLink": "Invia link di ripristino",
    "sending": "Invio in corso…",
    "backToLogin": "Torna al Login",
    "resendLink": "Reinvia email",
    "successTitle": "Controlla la tua email",
    "successBody": "Se esiste un account per {{email}}, abbiamo inviato un link di ripristino.",
    "linkExpires": "Il link scadrà tra 30 minuti.",
    "successToast": "Controlla l'email per le istruzioni di ripristino",
    "errEmptyEmail": "Inserisci il tuo indirizzo email",
    "errInvalidEmail": "Inserisci un indirizzo email valido",
    "errNetwork": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
    "errGeneric": "Invio email fallito. Riprova o contatta il supporto."
  },
  "resetPassword": {
    "title": "Imposta nuova password",
    "subtitle": "Crea una password sicura per il tuo account",
    "newPasswordLabel": "Nuova Password",
    "newPasswordPlaceholder": "Inserisci nuova password",
    "confirmPasswordLabel": "Conferma Password",
    "confirmPasswordPlaceholder": "Conferma la nuova password",
    "requirementsHint": "Deve contenere almeno 8 caratteri con maiuscole, minuscole e numeri",
    "resetPassword": "Reimposta Password",
    "resetting": "Reimpostazione in corso…",
    "successTitle": "Password reimpostata con successo!",
    "successBody": "Ora puoi accedere con la tua nuova password.",
    "successToast": "Password reimpostata con successo!",
    "goToLogin": "Vai al Login",
    "invalidLinkTitle": "Link non valido",
    "invalidLinkBody": "Questo link di ripristino non è valido o è scaduto.",
    "requestNewLink": "Richiedi un nuovo link",
    "showPassword": "Mostra password",
    "hidePassword": "Nascondi password",
    "errInvalidLink": "Link di ripristino non valido",
    "errMismatch": "Le password non corrispondono",
    "errTooShort": "La password deve avere almeno 8 caratteri",
    "errExpiredToken": "Questo link è scaduto o non valido. Richiedine uno nuovo.",
    "errNetwork": "Impossibile raggiungere il server. Controlla la connessione e riprova.",
    "errGeneric": "Reimpostazione fallita. Riprova."
  },
  "tips": {
    "water1": "Bere acqua entro 30 minuti dal risveglio può migliorare l'idratazione e i livelli di energia.",
    "water2": "Un bicchiere d'acqua prima di ogni pasto è un modo dolce per prevenire la sete.",
    "water3": "Aggiungere una fetta di limone o foglie di menta può rendere l'idratazione un piccolo piacere.",
    "meals1": "Aggiungere una porzione extra di verdure al giorno supporta la salute dell'intestino e del cuore.",
    "meals2": "Una manciata di noci o semi a colazione stabilizza l'energia per tutta la mattina.",
    "meals3": "La frutta intera è meglio del succo — le fibre rendono l'assorbimento degli zuccheri più lento.",
    "steps1": "Una passeggiata di 10 minuti dopo i pasti aiuta il corpo a gestire meglio gli zuccheri.",
    "steps2": "5 minuti di stretching mattutino possono allentare le tensioni e dare un tono calmo alla giornata.",
    "steps3": "Usare le scale anche solo una volta al giorno rinforza il cuore nel tempo.",
    "sleep1": "Abbassare le luci un'ora prima di andare a dormire aiuta il corpo a rilassarsi per un sonno profondo.",
    "sleep2": "Un orario di sveglia costante — anche nei fine settimana — stabilizza il ciclo del sonno.",
    "sleep3": "10 minuti di luce solare al mattino aiutano a regolare il ritmo del sonno in modo naturale.",
    "general1": "Due minuti di respirazione lenta possono ridurre lo stress e migliorare la concentrazione.",
    "general2": "Nota un momento di gratitudine oggi — anche i piccoli successi mentali contano.",
    "general3": "Oggi ci sei. Questa è l'abitudine che rende ogni altra abitudine più semplice."
  },
  "factors": {
    "hydration": "idratazione",
    "nutrition": "alimentazione",
    "movement": "movimento",
    "sleep": "sonno"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "Impossibile caricare le opzioni dei pasti",
    "prefsSaved": "Preferenze alimentari salvate! Aggiornamento pasti in corso...",
    "prefsSaveFail": "Impossibile salvare le preferenze",
    "newOptionsFail": "Impossibile caricare nuove opzioni",
    "invalidZip": "Inserisci un codice postale valido di 5 cifre",
    "noVendorsArea": "Ancora nessun fornitore disponibile in questa zona. Stiamo ampliando la copertura!",
    "vendorsFetchFail": "Impossibile recuperare i fornitori",
    "selectVendorFirst": "Seleziona prima un fornitore per la consegna",
    "removedFromCart": "Rimosso dal carrello",
    "orderPlaced": "Ordine effettuato con successo! 🎉",
    "enterZipFirst": "Inserisci prima il tuo codice postale nella sezione consegna",
    "mealNotAvailable": "Questo pasto non è ancora disponibile per la consegna nella tua zona",
    "mealUnavailable": "Questo pasto non è al momento disponibile presso i fornitori vicini",
    "vendorOptionsFail": "Impossibile caricare le opzioni del fornitore",
    "favoriteSaveFail": "Impossibile salvare nei preferiti",
    "removedFromFavorites": "Rimosso dai preferiti",
    "favoriteRemoveFail": "Impossibile rimuovere dai preferiti",
    "cartEmpty": "Il tuo carrello è vuoto",
    "noMealOptions": "Nessuna opzione di pasto disponibile",
    "loadingOptions": "Caricamento opzioni pasti...",
    "selectPreferences": "Seleziona le tue preferenze alimentari",
    "mealBuilder": "Crea Pasto",
    "myFavorites": "I miei Preferiti",
    "myFavoriteMeals": "I miei Pasti Preferiti",
    "noFavoritesYet": "Ancora nessun pasto preferito!",
    "price": "Prezzo",
    "delivery": "Consegna",
    "deliveryFee": "Costo di consegna",
    "distance": "Distanza",
    "subtotal": "Subtotale",
    "total": "Totale",
    "orderNumber": "Numero ordine",
    "vendor": "Fornitore",
    "totalAmount": "Importo totale",
    "estimatedDelivery": "Consegna stimata",
    "whyThisMeal": "Perché questo pasto",
    "selectThisMeal": "Seleziona questo pasto",
    "swapMeal": "Cambia pasto",
    "orderThisMeal": "Ordina questo pasto",
    "notAvailableNearYou": "Non disponibile nelle vicinanze",
    "tryAdjustingPrefs": "Prova a modificare le tue preferenze per vedere suggerimenti sui pasti",
    "myMealPlanSummary": "Riepilogo del mio piano alimentare",
    "saveCompletePlan": "Salva piano completo",
    "yourFoodPreferences": "Le tue preferenze alimentari",
    "editPreferences": "Modifica preferenze",
    "healthyMealDelivery": "Consegna pasti sani",
    "enableDelivery": "Attiva consegna",
    "enterZipCode": "Inserisci il CAP per vedere i pasti disponibili",
    "enterPostcode": "Inserisci il tuo codice postale / CAP",
    "postcodePlaceholder": "es. 00100 o 20121",
    "postcodePartialHint": "Inserisci il codice postale completo per risultati locali più precisi.",
    "noLocalPartnersFallback": "Nessun partner locale trovato. Ecco alcuni suggerimenti sugli ingredienti basati sulle tue abitudini.",
    "noLivePartnersFallback": "Ancora nessun partner alimentare HealthLoop attivo nella tua zona.",
    "culturalNutritionTitle": "Scoperta benessere locale",
    "culturalNutritionSubtitle": "Guida personalizzata per uno stile di vita sano: pertinente, informativa e adattata alla tua zona.",
    "viewIngredientGuidance": "Visualizza guida",
    "popularWellnessTitle": "Cibi sani popolari vicino a te",
    "popularWellnessIntro": "Ingredienti tipici e ambienti alimentari sani che le persone solitamente esplorano nella tua zona.",
    "subsectionPopularFoodsTitle": "Cibi per il benessere quotidiano",
    "subsectionCulturalIngredientsTitle": "Suggerimenti sugli ingredienti tipici",
    "subsectionHealthySwapsTitle": "Idee per scambi salutari",
    "subsectionLocalEnvironmentTitle": "Ambiente benessere locale",
    "subsectionLocalEnvironmentIntro": "Luoghi dove le persone nella tua zona trovano spesso opzioni sane e tradizionali.",
    "findLocalTitle": "Opzioni sane locali",
    "findLocalSubtitle": "Scopri fornitori sani, negozi e ingredienti tipici nella tua zona.",
    "findOptions": "Trova opzioni",
    "searching": "Ricerca in corso...",
    "nearbyVendorsFound": "{{count}} opzioni sane trovate nelle vicinanze",
    "orderHintEnabled": "Tocca \"Ordina questo pasto\" su qualsiasi scheda pasto qui sotto per vedere i prezzi del fornitore.",
    "orderHintDisabled": "Attiva \"Consegna\" qui sopra per ordinare uno di questi pasti direttamente dalle schede.",
    "localIngredientTitle": "Disponibilità ingredienti locali",
    "localIngredientIntro": "Alimenti base tipici e dove reperirli localmente.",
    "lookFor": "Cerca",
    "noVendorsFallback": "Nessun fornitore di consegna certificato qui — la guida agli ingredienti qui sopra è valida per qualsiasi supermercato o mercato locale.",
    "showingMealsFrom": "Visualizzazione pasti da",
    "sectionSnapshot": "Istantanea nutrizionale giornaliera",
    "sectionSnapshotSubtitle": "Uno sguardo rapido a idratazione, calorie e bilanciamento dei pasti di oggi.",
    "snapshotHydration": "Idratazione",
    "snapshotHydrationHint": "Punta a 6–8 bicchieri oggi.",
    "snapshotCalories": "Calorie",
    "snapshotCaloriesHint": "Monitoraggio in arrivo.",
    "snapshotBalance": "Bilanciamento pasti",
    "mealsLogged": "pasti selezionati",
    "snapshotTip": "Consiglio benessere",
    "snapshotTipHint": "Aggiungi una verdura extra al tuo prossimo pasto.",
    "sectionRecommendations": "Suggerimenti smart",
    "sectionRecommendationsSubtitle": "Guida agli ingredienti tipici e idee per alternative sane.",
    "sectionGoals": "Obiettivi nutrizionali",
    "sectionGoalsSubtitle": "Monitora i risultati che contano per te.",
    "goalWeight": "Gestione del peso",
    "goalWeightDesc": "Pasti studiati per un obiettivo di peso sostenibile.",
    "goalEnergy": "Sostegno energetico",
    "goalEnergyDesc": "Energia costante per giornate lunghe e produttive.",
    "goalImmunity": "Sostegno immunitario",
    "goalImmunityDesc": "Scelte ricche di antiossidanti per restare in salute.",
    "goalFamily": "Nutrizione familiare",
    "goalFamilyDesc": "Include opzioni per bambini e per la maternità.",
    "sectionGuidance": "Guida ai pasti",
    "sectionGuidanceSubtitle": "Idee per colazione, pranzo, cena e spuntini da scambiare liberamente.",
    "futureNutritionTitle": "Supporto nutrizionale futuro",
    "futureNutritionBody": "Nutrizione personalizzata, partnership per pasti sani e supporto alimentare per la famiglia arriveranno su HealthLoop nei prossimi aggiornamenti.",
    "comingSoon": "In arrivo",
    "coverageLocalStores": "Negozi di alimenti sani",
    "coverageLocalFarms": "Aziende agricole locali",
    "coverageCertifiedVendors": "Fornitori certificati",
    "coverageFreshProduce": "Prodotti freschi",
    "medWellnessFutureTitle": "Supporto benessere",
    "medWellnessFutureDesc": "Abbina il tuo piano nutrizionale a una guida attenta al tuo benessere. Trovi tutto sotto Supporto e Aiuto.",
    "pharmacyAssistFutureTitle": "Assistenza farmaceutica",
    "pharmacyAssistFutureDesc": "Trova farmacie vicine e promemoria direttamente accanto ai tuoi pasti. Trovi tutto sotto Supporto e Aiuto.",
    "savePreferences": "Salva preferenze",
    "quickAccessSavedMeals": "Accesso rapido ai tuoi pasti salvati",
    "saveMealsFromBuilder": "Salva i pasti dalla scheda Crea Pasto",
    "chooseVendor": "Scegli un fornitore per ordinare questo pasto",
    "yourCart": "Il tuo carrello",
    "addMealsToStart": "Aggiungi i pasti dalle opzioni qui sotto per iniziare",
    "orderPlacedDesc": "Il tuo ordine di pasti sani è stato effettuato con successo",
    "continueShopping": "Continua gli acquisti",
    "trackOrder": "Segui l'ordine",
    "healthyStoresTitle": "Negozi Salutari e Mercati del Benessere nelle Vicinanze",
    "healthyStoresIntro": "Tipologie di negozi inclusivi da cercare nella tua zona — spunti per la tua spesa, non per la consegna a domicilio.",
    "healthyStoresGuidanceTitle": "Guida alla spesa salutare",
    "healthyStoresDisclaimer": "HealthLoop condivide esclusivamente ispirazione per il benessere generale e la spesa salutare — non fornisce consigli medici o trattamenti dietetici.",
    "healthyStores": {
      "organic": {
        "type": "Negozi di alimentari biologici",
        "description": "Prodotti freschi senza pesticidi e alimenti di base minimamente lavorati.",
        "tags": [
          "Alimenti integrali",
          "Prodotti freschi"
        ]
      },
      "farmers": {
        "type": "Mercati agricoli",
        "description": "Frutta e verdura di stagione a km zero e prodotti tradizionali direttamente dai produttori.",
        "tags": [
          "Locale",
          "Stagionale"
        ]
      },
      "african": {
        "type": "Negozi di prodotti freschi africani",
        "description": "Igname, platani, verdure a foglia verde, noci di palma e alimenti base dell'Africa occidentale e orientale.",
        "tags": [
          "Culturale",
          "Prodotti freschi"
        ]
      },
      "caribbean": {
        "type": "Mercati di alimenti naturali caraibici",
        "description": "Callaloo, manioca, peperoncino scotch bonnet, ackee, frutti dell'albero del pane e specialità delle isole.",
        "tags": [
          "Culturale",
          "Alimenti integrali"
        ]
      },
      "asian": {
        "type": "Supermercati di verdure asiatiche",
        "description": "Bok choy, daikon, radice di loto, tofu, erbe fresche e alimenti base pan-asiatici.",
        "tags": [
          "Culturale",
          "Prodotti freschi"
        ]
      },
      "halal": {
        "type": "Mercati di alimenti salutari Halal",
        "description": "Proteine magre certificate Halal, prodotti freschi e spezie tradizionali.",
        "tags": [
          "Halal",
          "Culturale"
        ]
      },
      "mediterranean": {
        "type": "Mercati di alimenti integrali mediterranei",
        "description": "Olio d'oliva, legumi, erbe fresche, cereali integrali e pilastri della dieta mediterranea.",
        "tags": [
          "Culturale",
          "Alimenti integrali"
        ]
      },
      "wellness": {
        "type": "Negozi di alimentari orientati al benessere",
        "description": "Selezione di alimenti integrali, opzioni a base vegetale e prodotti con etichetta pulita.",
        "tags": [
          "Alimenti integrali",
          "A base vegetale"
        ]
      }
    },
    "healthyShoppingTips": [
      "Fai acquisti partendo dal perimetro: i prodotti freschi, le proteine magre e le alternative ai latticini si trovano solitamente lungo i bordi.",
      "Privilegia alimenti integrali con un solo ingrediente rispetto a quelli eccessivamente lavorati.",
      "Scegli prodotti locali stagionali: di solito sono più freschi, economici e ricchi di nutrienti.",
      "Chiedi ai venditori l'origine e i metodi di coltivazione: molti saranno felici di condividere queste informazioni."
    ]
  },
  "messages": {
    "success": "Successo!",
    "error": "Errore",
    "saved": "Salvato con successo",
    "updated": "Aggiornato con successo",
    "deleted": "Eliminato con successo",
    "confirmDelete": "Sei sicuro di voler eliminare questo elemento?",
    "networkError": "Errore di rete. Riprova.",
    "somethingWrong": "Qualcosa è andato storto",
    "failedToLoad": "Impossibile caricare la bacheca",
    "offlineMode": "Modalità offline – visualizzazione dati limitata",
    "locationDenied": "Accesso alla posizione negato. Controlla le impostazioni del browser.",
    "locationUnavailable": "Informazioni sulla posizione non disponibili",
    "locationTimeout": "Richiesta di posizione scaduta. Riprova.",
    "locationError": "Impossibile accedere alla posizione",
    "locationGranted": "Accesso alla posizione consentito! Visualizzazione opzioni vicine",
    "locationNotSupported": "Servizi di localizzazione non supportati dal tuo browser",
    "requestingLocation": "Richiesta di accesso alla posizione..."
  },
  "trust": {
    "medicalDisclaimer": "Dichiarazione di limitazione di responsabilità",
    "privacySecure": "I tuoi dati sono riservati e sicuri",
    "dataEncrypted": "Tutti i dati sono crittografati e confidenziali",
    "notMedicalAdvice": "Non è un parere medico",
    "consultProvider": "Consulta sempre il tuo medico",
    "evidenceBased": "Guida basata su evidenze",
    "generalEducation": "Educazione alla salute generale",
    "preventiveGuidance": "Guida preventiva",
    "lifestyleSupport": "Per consapevolezza e supporto allo stile di vita",
    "lastUpdated": "Ultimo aggiornamento",
    "expertReviewed": "Revisionato da esperti",
    "aiGenerated": "Analisi generata da IA",
    "disclaimerShort": "HealthLoop offre educazione sanitaria e non sostituisce il parere di un professionista medico.",
    "disclaimerFull": "HealthLoop supporta il benessere preventivo e la consapevolezza precoce. Forniamo educazione sanitaria, monitoraggio delle abitudini e approfondimenti sul benessere. Questo non sostituisce l'assistenza medica autorizzata. Consulta sempre operatori sanitari qualificati per orientamento, diagnosi o necessità mediche.",
    "trustBanner": {
      "title": "HealthLoop è qui per sostenere il tuo percorso di benessere",
      "description": "Forniamo educazione sanitaria generale e guida preventiva basata su fonti attendibili. Questo non sostituisce il parere di un medico professionista. Consulta sempre operatori sanitari qualificati per decisioni mediche."
    }
  },
  "health": {
    "preventiveHealth": "Tracker salute preventiva",
    "educationHub": "Centro educativo",
    "engagementWidget": "Widget attività",
    "wellnessCheckIn": "Check-in del benessere",
    "todaysMetrics": "Metriche di oggi",
    "bloodPressure": "Pressione sanguigna",
    "heartRate": "Frequenza cardiaca",
    "weight": "Peso",
    "sleep": "Sonno",
    "waterIntake": "Assunzione d'acqua",
    "exercise": "Esercizio fisico",
    "logMetric": "Registra metrica",
    "viewHistory": "Visualizza cronologia"
  },
  "aiInsights": {
    "title": "Analisi della salute IA",
    "comingSoon": "Stiamo raccogliendo i tuoi dati",
    "comingSoonDesc": "Completa uno o due check-in giornalieri e mostreremo qui approfondimenti personalizzati.",
    "learnMore": "Scopri di più",
    "evidenceSources": {
      "WHO": "Basato sulle linee guida OMS",
      "NHS": "In linea con le raccomandazioni NHS",
      "CDC": "Supportato dalle linee guida CDC",
      "RESEARCH": "Basato su ricerche peer-reviewed",
      "CLINICAL": "Supportato da studi clinici"
    }
  },
  "dailyInsight": {
    "title": "Analisi salute quotidiana",
    "gettingStarted": "Per iniziare",
    "focus": "Focus",
    "quickInsight": "Analisi rapida",
    "simpleExplanation": "Spiegazione semplice",
    "realLifeImpact": "Impatto reale",
    "yourActionStep": "Cosa puoi fare",
    "basedOnYour": "In base al tuo",
    "personalizedFor": "Personalizzato per te in base ai tuoi dati recenti",
    "getNewInsight": "Nuova analisi",
    "newInsightLoaded": "Nuova analisi caricata! 💡",
    "failedToRefresh": "Impossibile aggiornare l'analisi",
    "priority": {
      "high": "Concentriamoci qui",
      "medium": "Da notare"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "Nessun avviso al momento",
    "noAlertsDesc": "Stai mantenendo abitudini sane. Continua così!",
    "whatYouCanDo": "Cosa puoi fare:",
    "viewMealSuggestions": "Vedi suggerimenti pasti personalizzati"
  },
  "engagement": {
    "currentStreak": "Serie attuale",
    "bestStreak": "Serie migliore",
    "thisWeek": "Questa settimana",
    "exerciseDays": "Giorni di esercizio",
    "hydrationDays": "Giorni di idratazione",
    "healthMetricsLogged": "Metriche registrate",
    "weeklyGoalsProgress": "Progressi obiettivi settimanali",
    "completed": "completato",
    "days": "giorni",
    "keepGoing": "Continua così!",
    "personalRecord": "Record personale!",
    "goalMet": "Obiettivo raggiunto!"
  },
  "reminders": {
    "title": "Promemoria salute",
    "subtitle": "Resta in carreggiata con notifiche personalizzate",
    "breakfast": "Promemoria colazione",
    "lunch": "Promemoria pranzo",
    "dinner": "Promemoria cena",
    "water": "Assunzione d'acqua",
    "movement": "Pausa movimento",
    "sleep": "Promemoria sonno",
    "wellness": "Check-in del benessere",
    "healthLogging": "Registrazione dati salute",
    "annualCheckup": "Controllo annuale",
    "enable": "Attiva",
    "disable": "Disattiva",
    "customize": "Personalizza orario",
    "stayConsistent": "Sii costante con i promemoria smart",
    "setupFriendly": "Imposta promemoria gentili per aiutarti a creare abitudini sane.",
    "customizeWhen": "Puoi personalizzare quando e quanto spesso ricevere ogni promemoria.",
    "supportive": "Non preoccuparti, saranno sempre discreti e motivanti! 💚",
    "noPreferences": "Nessuna preferenza trovata",
    "noPreferencesDesc": "Non è stato possibile caricare le impostazioni dei promemoria. Potrebbe essere la tua prima volta qui o c'è stato un errore.",
    "retryLoading": "Riprova caricamento",
    "saveSettings": "Salva impostazioni",
    "saving": "Salvataggio..."
  },
  "empty": {
    "startJourney": "Inizia il tuo percorso di benessere",
    "startJourneyDesc": "Comincia oggi! Condividi come ti senti per ricevere analisi personalizzate e monitorare il tuo benessere nel tempo.",
    "completeFirstCheckIn": "Completa il primo check-in",
    "stayOnTrack": "Resta in carreggiata",
    "stayOnTrackDesc": "Sii costante con la tua routine 💊 Aggiungi le tue necessità per ricevere promemoria gentili e supporto.",
    "addFirstMedication": "Aggiungi il primo elemento",
    "learnMedicationSafety": "Scopri di più sulla sicurezza",
    "buildMealLibrary": "Crea la tua libreria dei pasti",
    "buildMealLibraryDesc": "Ancora nessun pasto preferito. Salva i piatti che ami per un accesso rapido e una pianificazione più semplice.",
    "exploreMealOptions": "Esplora le opzioni dei pasti",
    "insightsAwait": "Le tue analisi ti aspettano",
    "insightsAwaitDesc": "Completa i check-in giornalieri e monitora il tuo benessere per sbloccare analisi della salute e schemi personalizzati.",
    "startDailyCheckIn": "Inizia il check-in giornaliero",
    "learnAboutInsights": "Scopri di più sulle analisi",
    "buildingStory": "Costruisci la tua storia di benessere",
    "buildingStoryDesc": "Ancora nessun dato storico. Le tue tendenze e i tuoi schemi appariranno qui man mano che completi i check-in.",
    "completeCheckIn": "Completa check-in",
    "tipComplete7Days": "Consiglio: Completa i check-in per 7 giorni per vedere tendenze significative.",
    "startTrackingHabits": "Inizia a monitorare le abitudini sane",
    "startTrackingHabitsDesc": "Ancora nessuna abitudine monitorata. Piccole azioni quotidiane creano cambiamenti duraturi. Inizia oggi la tua routine.",
    "trackFirstHabit": "Monitora la prima abitudine",
    "getMoving": "Mettiti in movimento",
    "getMovingDesc": "Ancora nessuna attività registrata. Anche solo 10 minuti di movimento possono migliorare umore ed energia.",
    "logActivity": "Registra attività",
    "allCaughtUp": "Tutto aggiornato!",
    "allCaughtUpDesc": "Non hai nuove notifiche. Torna più tardi per aggiornamenti e promemoria.",
    "noResultsFound": "Nessun risultato trovato",
    "noResultsFoundDesc": "Non abbiamo trovato risultati per \"{query}\". Prova a modificare la ricerca o esplora altre opzioni."
  },
  "footer": {
    "tagline": "Il tuo compagno per la salute preventiva basato su IA",
    "builtWith": "Creato con cura per il tuo percorso di benessere",
    "allRightsReserved": "Tutti i diritti riservati.",
    "about": "Chi siamo",
    "privacy": "Privacy",
    "terms": "Termini",
    "contact": "Contatti",
    "helpCenter": "Centro Assistenza"
  },
  "modals": {
    "feedback": {
      "title": "Condividi il tuo feedback",
      "subtitle": "Aiutaci a migliorare HealthLoop",
      "whatWorking": "Cosa sta funzionando bene?",
      "whatImprove": "Cosa potremmo migliorare?",
      "placeholder": "Condividi i tuoi pensieri...",
      "thankYou": "Grazie per il tuo feedback!",
      "submitted": "Il tuo feedback ci aiuta a rendere HealthLoop migliore."
    },
    "reportProblem": {
      "title": "Segnala un problema",
      "subtitle": "Aiutaci a correggere i bug e a migliorare l'app",
      "describe": "Descrivi il problema",
      "placeholder": "Cosa è successo? Sii il più specifico possibile...",
      "optional": "Opzionale: Passaggi per riprodurre l'errore",
      "stepsPlaceholder": "1. Ho cliccato su...\n2. Poi ho...",
      "thankYou": "Grazie per la segnalazione!",
      "submitted": "Ce ne occuperemo subito."
    },
    "mealPreferences": {
      "title": "Personalizza i tuoi pasti",
      "subtitle": "Raccontaci le tue preferenze alimentari",
      "cuisines": "Cucine preferite",
      "selectCuisines": "Seleziona tutte quelle che desideri",
      "dietary": "Preferenze dietetiche",
      "selectDietary": "Seleziona le tue esigenze alimentari",
      "allergies": "Allergie e restrizioni",
      "allergiesPlaceholder": "es. Frutta a guscio, crostacei, glutine",
      "save": "Salva preferenze",
      "saving": "Salvataggio in corso..."
    },
    "upgrade": {
      "title": "Passa a Premium",
      "subtitle": "Sblocca tutte le funzionalità",
      "features": "Funzionalità Premium",
      "getStarted": "Inizia ora",
      "learnMore": "Scopri di più"
    }
  },
  "login": {
    "title": "La tua piattaforma intelligente per la salute preventiva",
    "subtitle": "Monitora, impara e agisci prima che sorgano problemi. Creata per la prevenzione, l'educazione, il coinvolgimento e il benessere.",
    "email": "Email",
    "password": "Password",
    "signIn": "Accedi",
    "signingIn": "Accesso in corso...",
    "forgotPassword": "Password dimenticata?",
    "noAccount": "Non hai un account?",
    "createAccount": "Creane uno",
    "biometricLogin": "Accedi con dati biometrici",
    "biometricHelper": "Usa impronta digitale, Face ID o Windows Hello",
    "authenticating": "Autenticazione in corso...",
    "vendorPartner": "Sei un partner commerciale?",
    "vendorLogin": "Accesso Partner",
    "emailRequired": "Inserisci prima la tua email",
    "biometricSuccess": "Accesso biometrico effettuato con successo! 🎉",
    "noPasskeys": "Accesso biometrico non configurato. Usa prima la password.",
    "biometricCancelled": "Accesso biometrico annullato",
    "biometricFailed": "Accesso biometrico fallito. Riprova con la password."
  },
  "register": {
    "title": "Unisciti a HealthLoop",
    "subtitle": "Inizia oggi il tuo percorso di salute preventiva",
    "fullName": "Nome e cognome",
    "email": "Email",
    "password": "Password",
    "confirmPassword": "Conferma Password",
    "createAccount": "Crea Account",
    "haveAccount": "Hai già un account?",
    "signIn": "Accedi",
    "creating": "Creazione account...",
    "passwordTooShort": "La password deve contenere almeno 8 caratteri",
    "setupBiometric": "Configura l'accesso biometrico",
    "setupBiometricDesc": "Usa l'impronta digitale, Face ID o Windows Hello per un accesso più rapido e sicuro",
    "setupNow": "Configura ora",
    "skipForNow": "Salta per ora",
    "settingUp": "Configurazione in corso...",
    "benefit1": "Nessuna password da ricordare",
    "benefit2": "Più sicuro grazie alla verifica biometrica",
    "benefit3": "Accedi con un tocco o uno sguardo",
    "biometricPrivacy": "I tuoi dati biometrici non lasciano mai il tuo dispositivo",
    "biometricSuccess": "Accesso biometrico configurato con successo! 🎉",
    "biometricFailed": "Impossibile configurare l'accesso biometrico. Puoi farlo più tardi nelle impostazioni.",
    "biometricSetupLater": "Puoi configurare l'accesso biometrico in seguito nelle impostazioni del tuo profilo"
  },
  "womensHealthPage": {
    "title": "Monitoraggio Salute Donna",
    "subtitle": "Monitora il ciclo, i sintomi e il benessere",
    "cycleOverview": "Panoramica del ciclo",
    "currentPhase": "Fase attuale",
    "nextPeriod": "Previsione prossimo ciclo",
    "logPeriod": "Registra ciclo",
    "logSymptoms": "Registra sintomi",
    "insights": "Analisi del ciclo",
    "tips": "Consigli in base alla fase",
    "history": "Cronologia cicli",
    "noData": "Ancora nessun dato sul ciclo",
    "noDataDesc": "Inizia a monitorare il tuo ciclo per ricevere analisi e previsioni personalizzate.",
    "startTracking": "Inizia monitoraggio"
  },
  "notifications": {
    "title": "Notifiche",
    "markAllRead": "Segna tutte come lette",
    "noNotifications": "Nessuna nuova notifica",
    "viewAll": "Vedi tutte"
  },
  "familyHealth": {
    "title": "Salute della Famiglia e dei Bambini",
    "subtitle": "Supporto per la salute preventiva di tutta la tua famiglia",
    "tabImmunizations": "Vaccinazioni",
    "tabEducation": "Educazione",
    "tabReminders": "Promemoria",
    "tabPlanner": "Agenda Famiglia",
    "immunizations": {
      "title": "Consapevolezza Vaccinale",
      "subtitle": "Resta informato sui vaccini raccomandati",
      "recommendedSchedule": "Calendario raccomandato",
      "byAge": "Per fascia d'età",
      "infants": "Neonati (0-12 mesi)",
      "toddlers": "Bambini (1-3 anni)",
      "preschool": "Età prescolare (4-6 anni)",
      "schoolAge": "Età scolare (7-12 anni)",
      "teens": "Adolescenti (13-18 anni)",
      "adults": "Adulti",
      "learnMore": "Scopri di più",
      "consultDoctor": "Consulta sempre il tuo operatore sanitario per raccomandazioni vaccinali personalizzate",
      "upcomingReminders": "Prossimi promemoria vaccini",
      "noReminders": "Nessun promemoria vaccini in arrivo",
      "addReminder": "Aggiungi promemoria vaccino",
      "reminderFor": "Promemoria per",
      "dueDate": "Scadenza",
      "notes": "Note",
      "markComplete": "Segna come completato"
    },
    "education": {
      "title": "Educazione alla Salute Familiare",
      "subtitle": "Informazioni sulla salute preventiva basate su evidenze",
      "categories": "Categorie",
      "infant": "Cura del neonato",
      "child": "Sviluppo del bambino",
      "nutrition": "Nutrizione e crescita",
      "safety": "Sicurezza e prevenzione",
      "mental": "Benessere mentale",
      "hygiene": "Igiene e abitudini",
      "searchPlaceholder": "Cerca argomenti di salute...",
      "popularTopics": "Argomenti popolari",
      "readMore": "Leggi di più",
      "readTime": "min di lettura"
    },
    "reminders": {
      "title": "Promemoria Salute Famiglia",
      "subtitle": "Resta in linea con le cure preventive per tutta la famiglia",
      "createReminder": "Crea promemoria",
      "familyMember": "Membro della famiglia",
      "reminderType": "Tipo di promemoria",
      "frequency": "Frequenza",
      "activeReminders": "Promemoria attivi",
      "upcomingThisWeek": "In arrivo questa settimana",
      "noActiveReminders": "Nessun promemoria attivo",
      "types": {
        "checkup": "Controllo medico",
        "dental": "Visita dentistica",
        "vision": "Esame della vista",
        "vaccine": "Vaccinazione",
        "medication": "Farmaco",
        "custom": "Personalizzato"
      }
    },
    "planner": {
      "title": "Agenda Salute Famiglia",
      "subtitle": "Coordina le cure preventive per la tua famiglia",
      "addMember": "Aggiungi membro",
      "memberName": "Nome del membro",
      "relationship": "Relazione",
      "dateOfBirth": "Data di nascita",
      "viewCalendar": "Vedi calendario",
      "upcomingCare": "Prossime cure preventive",
      "nothingScheduled": "Nulla di programmato al momento",
      "scheduleCheckup": "Prenota controllo",
      "relationships": {
        "child": "Figlio/a",
        "spouse": "Coniuge",
        "parent": "Genitore",
        "sibling": "Fratello/Sorella",
        "other": "Altro"
      }
    },
    "content": {
      "infantCare": {
        "title": "Cura Preventiva del Neonato",
        "intro": "Pratiche essenziali di salute preventiva per il primo anno del tuo bambino",
        "topics": [
          "Calendario dei controlli pediatrici",
          "Tappe dello sviluppo da monitorare",
          "Pratiche per il sonno sicuro",
          "Nutrizione e allattamento",
          "Calendario vaccinale"
        ]
      },
      "childDevelopment": {
        "title": "Sviluppo del Bambino e Tappe Fondamentali",
        "intro": "Comprendere una crescita e uno sviluppo sani",
        "topics": [
          "Tappe dello sviluppo fisico",
          "Crescita sociale ed emotiva",
          "Sviluppo del linguaggio",
          "Tappe cognitive",
          "Quando parlare con il medico"
        ]
      },
      "nutrition": {
        "title": "Nutrizione e Crescita Sana",
        "intro": "Costruire sane abitudini alimentari fin dall'inizio",
        "topics": [
          "Nutrizione adeguata all'età",
          "Idee per spuntini sani",
          "Gestire i bambini dai gusti difficili",
          "Basi di sicurezza alimentare",
          "Linee guida per l'idratazione"
        ]
      },
      "safety": {
        "title": "Sicurezza e Prevenzione Infortuni",
        "intro": "Creare un ambiente sicuro per la tua famiglia",
        "topics": [
          "Checklist per la sicurezza domestica",
          "Sicurezza dei seggiolini auto",
          "Sicurezza in acqua",
          "Prevenzione degli avvelenamenti",
          "Preparazione alle emergenze"
        ]
      }
    }
  }
};
